//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState, useContext, useMemo } from 'react';

// === CONSTANTS ===
import { SUCCESS_CODE } from 'constants/general';

// === COMPONENTS ===
import { Select as CustomSelect } from 'components/Select';
import { FieldPanelContext } from '../../../FieldPanelContext/FieldPanelContext';
import { validate } from './validation/index';

// === API ===
import { requestPreviousFieldFocus, updateField } from "api/prokey/prokey.websocket";

//#endregion

export { validate };

//-----------------------------------------------------------------
export function Pagetype( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { field } = props;

  const {
    doctypes,
  } = useContext( FieldPanelContext );

  const [ content, setContent ] = useState( props.value );

  const options = useMemo( createOptions, [doctypes] );

  field.validationInfo.acceptableValues = doctypes ? Object.values(doctypes[0].options).map( x => x.value ) : [];

  //#endregion
  
  //#region [STYLES]
  const pt_style = {
    ...props.style,
    width: '100%',
  }

  //#endregion

  //#region [METHOD] 

  //-----------------------------------------------------------------
  function createOptions() {
    //-----------------------------------------------------------------
    const identified = getIndentified();
    const alternativ = getLikelies();
  
    const items = [ ];
    if( identified.options.length > 0 ) items.push( identified  );
    if( alternativ.options.length > 0 ) items.push( alternativ  );
    if( doctypes          .length > 0 ) items.push( ...doctypes );

    return items;
  }

  //-----------------------------------------------------------------
  function getNumCode(doctype) {
    //-----------------------------------------------------------------
    if (!doctype) return '';

    let numCode = doctype;
    if (numCode[0] === 'D') numCode = numCode.slice(1);
    if (numCode[0] === 'F') numCode = 'F';
    if (numCode[0] === 'B') numCode = 'B';

    let label = numCode;
    return label;
  }

  //-----------------------------------------------------------------
  function getLabel(doctype) {
    //-----------------------------------------------------------------
    // if (is_changing) return value;
    let result = getNumCode(doctype);
    const full_list = doctypes.find((x) => x.label === 'Full').options;
    const option_filter = full_list.find((x) => x.value.toUpperCase() === result.toUpperCase());
    const match_found = !!option_filter;

    if (match_found) {
      result = option_filter.label;
    }
    return result;
  }

  //-----------------------------------------------------------------
  function getIndentified() {
    //-----------------------------------------------------------------
    const identified = field.DisplayInfo.IdentifiedValue;

    const result = {
      label   : 'Identified',
      options : [],
    }

    if(!identified) return result;

    const option = { label: getLabel(identified), value: getNumCode(identified) };
    result.options.push( option )

    return result;
  }

  //-----------------------------------------------------------------
  function getLikelies() {
    //-----------------------------------------------------------------
    const result = {
      label: 'Likely Alternatives',
      options: [],
    };

    const alternatives = field.DisplayInfo.AltContent;

    for (const numCode of alternatives) {
      const option = { label: getLabel(numCode), value: getNumCode(numCode) };
      const is_duplicate =   result.options.findIndex( x => x.value === option.value );
      if( is_duplicate < 0 ) result.options.push(option);
    };

    return result;
  }


  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onChange( event ) {
    //-----------------------------------------------------------------
    const value = event.target ? event.target.value : event.value;
    if( event.isSubmit ) {
      setContent( value );
      const result = validate( value, field.validationInfo );
      if( result.status === SUCCESS_CODE ) updateField( event.trigger, props.field.id, props.field.Name, { Content: result.content } );
    }
  }

  //-----------------------------------------------------------------
  function onKeyDown( event ) {
    //-----------------------------------------------------------------
    try {
      const is_action_prev = event.key === 'Tab' && event.shiftKey ;
      if( is_action_prev ) {
        event.preventDefault();
        event.stopPropagation();
        requestPreviousFieldFocus( props.id );
      }
    } catch (error) {
      console.warn(error);
    }
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <CustomSelect
        name={props.name}
        id={props.id}
        inputStyle={pt_style}
        options={options}
        value={getLabel(content)}
        forceSelected={true}
        innerRef={props.inputRef}
        has_focus={props.has_focus}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onBlur={props.onBlur}
        disabled={field.isReadOnly}
      />
    );
  }

  //#endregion

  return display();
}